import React from "react";
import { Props } from "./Props";

import * as Styled from "./styles";

const OptionStep: React.FC<Props> = ({
  number,
  title,
  children = null
}: Props) => (
  <Styled.OptionStep>
    <Styled.TitleStep>
      <Styled.StepNumber>{number}</Styled.StepNumber>
      <Styled.StepDescription>{title}</Styled.StepDescription>
    </Styled.TitleStep>
    {children && <Styled.BodyStep>{children}</Styled.BodyStep>}
  </Styled.OptionStep>
);

export default OptionStep;
